// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610230506/js/" + chunkId + "." + {"44":"cbab54ac","225":"fd989366","481":"b75d272a","486":"9f777c10","770":"2807f372"}[chunkId] + ".0.8747758045516878.chunk.js";
};